import App from './modules/App/App'
import Home from './modules/Home/Home'
import Letters from './modules/Letters/Letters'
import Letter from './modules/Letter/Letter'
import Contact from './modules/Contact/Contact'
import Pledges from './modules/Pledges/Pledges'
import Pledge from './modules/Pledge/Pledge'
import Resources from './modules/Resources/Resources'
import Supporters from './modules/Supporters/Supporters'

export const routes = [
    {
        component: App,
        routes: [
            { 
                path: '/',
                component: Home,
                exact: true,
            },
            { 
                path: '/letters',
                component: Letters,
                exact: true,
            },
            { 
                path: '/letter/:slug',
                component: Letter,
                exact: true,
            }, 
            { 
                path: '/pledge',
                component: Pledges,
                exact: true,
            },
            { 
                path: '/pledge/:slug',
                component: Pledge,
                exact: true,
            },
            { 
                path: '/supporters',
                component: Supporters,
                exact: true,
            },
            { 
                path: '/resources',
                component: Resources,
                exact: true,
            },
            { 
                path: '/contact',
                component: Contact,
                exact: true,
            }
        ]
    }
]


// WEBPACK FOOTER //
// ./client/routes.js